export default {
    noModels: 'Your Display Settings exclude all online models.',
    openSettings: 'Change your Display Settings',
    goodMorning: 'Good morning, {{username}}!',
    goodAfternoon: 'Good afternoon, {{username}}!',
    goodEvening: 'Good evening, {{username}}!',
}
